const addformdatadialog = [{
		inputdata: "",
		title: "单据号",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "80px",
		btx: false,
	},
	{
		inputdata: "",
		title: "寄售日期",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "datess",
		width: "180px",
		lablewith: "120px",
		btx: true,
	},
	{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "选择",
		types: "",
		inputtype: "select",
		width: "190px",
		btx: true,
		lablewith: "120px",
		options: [],
		event: "invClass",
	},
	{
		inputdata: null,
		title: "寄售方向",
		fontSize: "14px",
		color: "#333333",
		placeholder: "选择",
		types: "",
		inputtype: "select",
		width: "190px",
		btx: true,
		lablewith: "80px",
		options: [{
			key: '0',
			value: '寄售出'
		}, {
			key: '1',
			value: '寄售退'
		}],
	},
	{
		inputdata: "",
		title: "寄售公司",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "selectautocompletes",
		width: "215px",
		btx: true,
		lablewith: "120px",
		options: [],
		event: "HosTypeChage"
	},
	{
		inputdata: "",
		title: "备注",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "95px",
	}
];
export default addformdatadialog;